import { MARQUEE_ITEMS } from "@/data/siteData";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Marquee() {
  const { lang, t } = useLanguage();
  const source = lang === "en" ? MARQUEE_ITEMS : [1, 2, 3, 4, 5, 6, 7, 8].map((i) => t(`mq.${i}`));
  const items = [...source, ...source];
  return (
    <div data-testid="editorial-marquee" className="relative overflow-hidden border-y border-amber-500/20 bg-navy-deep py-4">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="flex items-center font-mono text-xs uppercase tracking-[0.3em] text-slate-400">
            <span className="px-6">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-amber-500" aria-hidden="true" />
          </span>
        ))}
      </div>
    </div>
  );
}
